<template>
  <drop-down
    :label="label"
    :item-key="itemKey"
    :placeholder="label"
    :select-drop-item="selectItem"
    :drop-items="levels"
    :selected-item="checkoutStore.getDetails[itemKey]"
    main-variant="prestige-selector"
  />
</template>

<script setup>
import DropDown from "~/components/custom/DropDown.vue";
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const props = defineProps({
  label: {
    default: "",
  },
  itemKey: {
    default: "",
  },
});

const levels = computed(() => {
  const prices = gameStore.getGamePack?.prices || [];
  if (prices.length > 0) {
    // console.log(prices);
    return prices.reduce((acc, value) => {
      return { ...acc, [value.id]: value.title };
    }, {});
  }
  return [];
});

const selectItem = (key, value) => {
  if (key === "currentPrestige" || key === "desiredPrestige") {
    checkoutStore.setDetails({
      ...checkoutStore.getDetails,
      [key]: parseInt(value),
      [`${key}Title`]: levels.value[parseInt(value)],
    });
  }
};
</script>
